(function () {
    'use strict';

    angular.module('NaviaqWebApp').factory('unitBatchService', unitBatchService);

    unitBatchService.$inject = ['$q', '$http', 'serviceUrls'];

    function unitBatchService($q, $http, serviceUrls) {
        const unitBatchWebApiUrl = `${serviceUrls.webApiBaseUrl}/unitBatch`;

        return {
            getUnitBatch: getUnitBatch,
            getUnitBatches: getUnitBatches,
            bulkArchiveUnitBatches: bulkArchiveUnitBatches,
            exportBatchCertificatesToZipFile
        };

        function getUnitBatch(unitBatchId) {
            const deferred = $q.defer();
            const requestUrl = `${unitBatchWebApiUrl}/byId?unitBatchId=${unitBatchId}`;

            $http
                .get(requestUrl)
                .then(response => deferred.resolve(response.data))
                .catch(error => deferred.reject(error));

            return deferred.promise;
        }

        function getUnitBatches(isActive = true) {
            const deferred = $q.defer();
            const requestUrl = `${unitBatchWebApiUrl}/list?isActive=${isActive}`

            $http
                .get(requestUrl)
                .then(response => deferred.resolve(response.data))
                .catch(error => deferred.reject(error));

            return deferred.promise;
        }

        function bulkArchiveUnitBatches(unitBatchIds) {
            const deferred = $q.defer();
            const requestUrl = `${unitBatchWebApiUrl}/bulkArchiveUnitBatches`

            $http
                .post(requestUrl, unitBatchIds)
                .then(response => deferred.resolve(response.data))
                .catch(error => deferred.reject(error));

            return deferred.promise;
        }

        function exportBatchCertificatesToZipFile(gridItems) {
            const deferred = $q.defer();

            $http({
                method: 'POST',
                url: `${unitBatchWebApiUrl}/exportBatchCertificatesToZipFile`,
                data: { gridItems },
                responseType: 'arraybuffer'
            })
                .then(response => {
                    deferred.resolve(response.data);
                })
                .catch(error => {
                    deferred.reject(error);
                });

            return deferred.promise;
        }
    }
})();
